import styled from 'styled-components';
import { theme } from '@kueski-dev/kueski-design-system';

const { breakpoint, spacing } = theme;

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  height: 100vh;
  height: 100dvh;
  justify-content: flex-start;
  margin: 0 auto;
  max-width: 24rem;
  padding: ${spacing.layout07} ${spacing.layout02};
  text-align: center;
  @media ${breakpoint.onlyPhone} {
    justify-content: space-between;
    padding: ${spacing.layout02};
  }
`;

export const FooterActions = styled.footer`
  align-items: start;
  display: flex;
  gap: 2.5rem;
  justify-content: center;
`;
